import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ScheduleEntrySelected } from '@/tools/params/class-builder.params';
import { Placeholder } from '@/tools/models/class-builder.models';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-class-subject-placeholder-to-block-modal',
  components: {
    EdClassSubjectPlaceholderItem: () => import(/* "EdClassSubjectPlaceholderItem" */ '../ed-class-subject-placeholder-item/ed-class-subject-placeholder-item.component.vue'),
  }
})
export default class EdClassSubjectPlaceholderToBlockModalComponent extends Vue {
  @Prop({}) readonly params: any;

  showAddPlaceholders: boolean = false;

  get isWeeklySchedule(): boolean {
    return this.params.isWeeklySchedule;
  }

  get placeholders(): Placeholder[] {
    return this.params.placeholders;
  }

  get blocksToAssign(): ScheduleEntrySelected[] {
    return this.params.blocksToAssign;
  }

  get blocksChecked(): ScheduleEntrySelected[] {
    return this.params.blocksChecked;
  }

  get blockToAssign(): ScheduleEntrySelected {
    return this.params.blockToAssign;
  }

  emitOnAddPlaceholdersSelected(): void {
    this.close();

    let blocks = [this.blockToAssign];
    if (this.hasToAddAllBlocksSelected.value) {
      blocks = this.blocksToAssign;
    } else if (this.blocksChecked.length > 0) {
      blocks = this.blocksChecked;
    }
    this.params.onAddPlaceholdersSelected({
      placeholders: this.placeholdersSelected,
      blocks,
      unrelatedPlaceholders: this.placeholdersUnrealtedToBlock
    })
  }

  emitOnGoToAddPlaceholders(): void {
    this.close();
    this.showAddPlaceholders = true;
  }

  isAddingPlaceholders = false;
  placeholdersSelected = [];
  placeholdersUnrealtedToBlock = [];
  hasToAddAllBlocksSelected: any = EdInputModel('hasToAddAllBlocksSelected', false, {}, true);

  onPlaceholderSelected(
    placeholderSelected: {placeholder: Placeholder, isSelected: boolean},
  ): void {
    const isSelected = placeholderSelected.isSelected;
    this.placeholdersUnrealtedToBlock = this.placeholdersUnrealtedToBlock.filter((placeholder) => placeholder.id !== placeholderSelected.placeholder.id);
    this.placeholdersSelected = this.placeholdersSelected.filter((placeholder) => placeholder.id !== placeholderSelected.placeholder.id);
    if(isSelected) {
      this.placeholdersSelected.push(placeholderSelected.placeholder);
    } else {
      this.placeholdersUnrealtedToBlock.push(placeholderSelected.placeholder);
    }
  }

  setPlaceholderSelected() {
    this.placeholdersSelected = [];
    this.placeholdersUnrealtedToBlock = [];
    this.placeholders.forEach((placeholder) => {
      const item: any = this.$refs[`placeholder${placeholder.id}`];
      
      if (item) {
        const placeholder = item[0].placeholder 
        const isSelected = item[0].isSelected
        if(isSelected) {
          this.placeholdersSelected.push(placeholder);
        } else {
          this.placeholdersUnrealtedToBlock.push(placeholder);
        }
      }
    })
  }

  open({ cache } = { cache: false }) {
    if (!cache) {
      this.resetSelection();
      this.hasToAddAllBlocksSelected.value = false;
    }

    this.isAddingPlaceholders = true;
  }

  resetSelection() {
    this.placeholdersSelected = [];
    this.placeholders.forEach((placeholder) => {
      const item: any = this.$refs[`placeholder${placeholder.id}`];
      
      if (item) {
        item[0].setSelectProp();
      }
    })
  }

  close() {
    this.$EdModal.closeModal();
  }

  mounted() {
    this.open(this.params.cache);
  }

  destroyed() {
    setTimeout(() => {
      if(this.showAddPlaceholders)
        this.params.onGoToAddPlaceholders(true);
    }, 100);
  }

  @Watch('isAddingPlaceholders')
  onIsAddingPlaceholdersChanged() {
    this.resetSelection();
    this.setPlaceholderSelected();
  }
}